import request from '@/utils/request'

/**
 * 获取前端配置
 * @returns {*}
 */
export function getFrontConfig() {
    return request({
        url: `/config`,
        method: 'get'
    })
}

/**
 * 获取当前登录的用户信息
 * @returns {AxiosPromise}
 */
export function getUserInfo() {
    return request({
        url: `/userInfo`,
        method: 'get'
    })
}
